import { Button } from '@mui/material';
import { useState } from 'react';
import ProjectDialog from './ProjectDialog';

/*
const initLanguages = [
  { code: 'da', name: 'Dansk' },
  { code: 'de', name: 'Deutsh' },
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
];
*/

function Settings() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClick = () => {
    setDialogOpen(true);
  };

  return (
    <div>
      <ProjectDialog open={dialogOpen} handleClose={() => setDialogOpen(false)} />
      <Button variant='contained' onClick={handleClick}>Create Project</Button>
    </div>
  );
}

export default Settings;
